// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * APPEND-ONLY. Range starts are pinned with an explicit `= N`; every other
 * member is numbered by declaration order, so the ordinal IS the wire value.
 *
 * Inserting, reordering or removing a member silently renumbers every member
 * after it up to the next explicit `= N`, which reinterprets every archived
 * message and every frame in flight — with no error anywhere, because the
 * wire value stays a valid member of the enum, just a different one. New
 * values go LAST, always.
 */
export enum Status {
  HighSpeedStartSequence = 0,
  RunningHighSpeed = 1,
  MGRequest = 2,
  LoadWeightDispatch = 3,
  DrvMgDriveOn = 4,
  PowerUpSequence = 5,
  DriveFaultOccured = 6,
  Power = 7,
  Safety = 8,
  FrontPhotoCellBroken = 9,
  RearPhotoCellBroken = 10,
  GateLock = 11,
  NoDemand = 12,
  HatchAccess = 13,
  CarTimedOut = 14,
  CarNotLoaded = 15,
  FrontDoorOpenButton = 16,
  FrontDoorCloseButton = 17,
  FrontSafetyEdgeActivated = 18,
  RearSafetyEdgeActivated = 19,
  RearDoorOpenButton = 20,
  RearDoorCloseButton = 21,
  HallShutdownSwitch = 22,
  CarShutdownSwitch = 23,
  Derailment = 24,
  PowerLimit1 = 25,
  PowerLimit2 = 26,
  ReducedSpeed = 27,
  DispatcherDown = 28,
  CarStopSwitchUp = 29,
  CarStopSwitchOpen = 30,
  CounterweightDerailment = 31,
  Earthquake = 32,
  HallIndependent = 33,
  MassMedical = 34,
  CodeBlueReturn = 35,
  DriveNotReady = 36,
  GripperFault = 37,
  IoError = 38,
  GateDoorLockFault = 39,
  WaitingForDoorClose = 40,
  WaitingForGateLock = 41,
  TopOfCarCommError = 42,
  DriveCommError = 43,
  DbResistorTemp = 44,
  CarToFloor = 45,
  SwingCar = 46,
  RearDoorOpenLimit = 47,
  CodeBlueActive = 48,
  UpCallDoorFlag = 49,
  CarCallTime = 50,
  HallCallTime = 51,
  MachineRoomTemperature = 52,
  NormalPower = 53,
  RearDoor6InchLimit = 54,
  CarCallAbove = 55,
  CarCallBelow = 56,
  CarCallDisconnect = 57,
  HallCallDisconnect = 58,
  HoldInputAnsi = 59,
  CancelFrontUp = 60,
  CancelFrontDown = 61,
  DriveEnableStatus = 62,
  SwingingService = 63,
  OverWeightBypass = 64,
  MedicalService = 65,
  CancelRearUp = 66,
  AlarmBell = 67,
  DoorZoneStatus = 68,
  CarCallEnable = 69,
  DoorOpenCommand = 70,
  ShutdownStatus = 71,
  EmergencyPowerTest = 72,
  ShuntTripHeatDetector = 73,
  MedicalEmergencyCarSwitch = 74,
  MedicalEmergencyHallSwitch = 75,
  HospitalServiceDemanded = 76,
  CarCaptureSecurityStatus = 77,
  OilTemperatureCold = 78,
  TelescopicResynch = 79,
  UpSpeedLimit = 80,
  HoistwayFrontGateClosed = 81,
  CarRearGateClosed = 82,
  TerminalReset = 83,
  StandardRiser = 84,
  SecondRiser = 85,
  PitSwitch = 86,
  AuxPowerCircuitBreaker = 87,
  BatteryChargerDisconnect = 88,
  BusyServingCalls = 89,
  NormalLoad = 90,
  NormalTrafficMode = 91,
  HeavyTwoWay = 92,
  DoorCloseInd = 93,
  OutOfServiceStatus = 94,
  AgvService = 95,
  SimplexServiceStatus = 96,
  EmergencyTrip1 = 97,
  ServitelOutOfOrder = 98,
  HospitalEmergencyTrip = 99,
  BypassStatus = 100,
  NextCarOperationStatus = 101,
  LockCabinCall = 102,
  LockFloorCallStatus = 103,
  EmPwrEvacFailed = 104,
  AlternativeFire = 105,
  AlternativeFireFighter = 106,
  TakingHallCalls = 107,
  CarDoorBypass = 108,
  HoistwayDoorBypass = 109,
  UseCurrentEligibility = 110,
  CloseButtonCancelsDwell = 111,
  LoadCancelsDwell = 112,
  ShuttleCcDispAnswer = 113,
  CcDispCancelImmediate = 114,
  MechanicOnSiteStatus = 115,
  CarStopSwitch = 116,
  CarIndependent = 117,
  LobbyPark = 118,
  LobbyRecall = 119,
  PowerEmPower = 120,
  FirePhase2Status = 121,
  CounterweightDerailmentStatus = 122,
  HallIndependentStatus = 123,
  MassMedicalStatus = 124,
  FrontDoorOpenDevice = 125,
  RearDoorOpenDevice = 126,
  RearDoorClosedLimit = 127,
  StopSwitchStatus = 128,
  AntiNuisanceStatus = 129,
  PhaseOnePosition = 130,
  WatchDogStatus = 131,
  GovernorTrip = 132,
  RearDoorStatus = 133,
  HallDoorLocks = 134,
  AutomaticService = 135,
  IndependentService = 136,
  CarDoorLocks = 137,
  DoorOpenLimit = 138,
  SerialOkFromDispatcher = 139,
  DoorCloseButtonStatus = 140,
  InGroupService = 141,
  LoadBypassStatus = 142,
  StatusNotAvailable = 143,
  IndependentServiceDemanded = 144,
  ContinuousOperation = 145,
  AccessMode = 146,
  ExerciseMode = 147,
  FrontDoorDisconnect = 148,
  FrontDoorPositionMonitor = 149,
  RearDoorDisconnected = 150,
  RearDoorPositionMonitor = 151,
  BottomDoorLockBypass = 152,
  IntermediateDoorLock = 153,
  TopDoorLockBypass = 154,
  DownSlowdownLimitOpen = 155,
  UpSlowdownLimitOpen = 156,
  MainFloorPulse = 157,
  DownNormalLimitOpen = 158,
  UpNormalLimitOpen = 159,
  MainLineDisconnect = 160,
  MachineRoomDoor = 161,
  SumpPumpOverflowStatus = 162,
  WaterInPitSensor = 163,
  OilInPitSensor = 164,
  OilLeakJackSensor = 165,
  MotorRoomHiTemp = 166,
  MotorRoomLoTemp = 167,
  PhoneLineMonitor = 168,
  AlarmBellPressed = 169,
  MechanicLeft = 170,
  PreparedToStart = 171,
  RearDoorNormal = 172,
  RearDoorDiagnostics = 173,
  RearDoorFailure = 174,
  RearDoorServiceStatus = 175,
  BankState = 176,
  NoConnection = 177,
  InspectionState = 178,
  TopOfCarInspection = 179,
  InCarInspection = 180,
  ControllerInspection = 181,
  NoInspectionNormal = 182,
  HoistwayAccessStatus = 183,
  InspectionBypass = 184,
  SecurityFlag = 185,
  PixFaultCode = 186,
  MotorThermal = 187,
  HallLocks = 188,
  LoadWeighingBypass = 189,
  Levelling = 190,
  AntiStallTimer = 191,
  ApeHydro = 192,
  BlockOperation = 193,
  DemandDown = 194,
  DemandUp = 195,
  DeltaSimulation = 196,
  DoorCloseCommand = 197,
  DoorDisconnectSwitch = 198,
  DoorEdgeFront = 199,
  DoorLockStatus = 200,
  DoorOpenButton = 201,
  DoorOpenLimitRear = 202,
  DoorStuck = 203,
  DownCallAbove = 204,
  DownCallBelow = 205,
  DownRun = 206,
  DownSlowDown = 207,
  DownStatus = 208,
  EarthquakeInput = 209,
  EmergencyMedicalTrip1 = 210,
  EmergencyMedicalTrip2 = 211,
  EmergencyPowerRun = 212,
  EmergencyTripStatus = 213,
  Entrapment = 214,
  FastSpeed = 215,
  FireServiceMain = 216,
  FireServiceStatus = 217,
  FireServiceZone = 218,
  FireSmokeDetectorsBypass = 219,
  HighSpeedStatus = 220,
  InServiceReady = 221,
  LevelDown = 222,
  LightLoadInput = 223,
  MgRunOutput = 224,
  MainLineDisconnectStatus = 225,
  MaxLoadStatus = 226,
  MechanicLeftSite = 227,
  MechanicOffsite = 228,
  MechanicOnsite = 229,
  MedicalServicePhase1 = 230,
  MedicalServicePhase2 = 231,
  MosLedIndicator = 232,
  MotorShutDown = 233,
  NormalAutomaticOperation = 234,
  OilTemperatureHigh = 235,
  OverTemperatureStatus = 236,
  PositionBottom = 237,
  PositionTop = 238,
  PressureSwitchStatus = 239,
  RearDoorCloseLimit = 240,
  RearSafetyEdgeActivatedStatus = 241,
  RelevelingSpeed = 242,
  RestrictedService = 243,
  ReversalDevice = 244,
  SecurityStatus = 245,
  ShuntTripStatus = 246,
  SpareStatus = 247,
  UpCallAbove = 248,
  UpCallBelow = 249,
  UpLeveling = 250,
  UpRun = 251,
  UpSlowDown = 252,
  UpStatus = 253,
  UpTerminalSlowdown = 254,
  WatchDogInput = 255,
  YSimulation = 256,
  M10Cleaner = 257,
  CodeBlueInCarOperation = 258,
  AuxiliaryPowerShutDown = 259,
  CarHasPowerToRun = 260,
  HallCallReject = 261,
  HeartBeatStatus = 262,
  LobbyRecallStatus = 263,
  FireService1 = 264,
  CarToLobbyStatus = 265,
  HoldInputAnsiStatus = 266,
  EmergencyPower = 267,
  Lock = 268,
  EarthquakeOff = 400,
  EarthquakeOn = 401,
  EarthquakeNormal = 402,
  EpNormal = 410,
  EpRun = 411,
  EpRecall = 412,
  EpFreeze = 413,
  EpRecallNextFloor = 414,
  EpInvalid = 415,
  Connected = 420,
  Disconnected = 421,
  Heartbeat = 422,
  ModeAttendant = 430,
  ModeSimplex = 431,
  ModeIR = 432,
  ModeVIP = 433,
  ModeSecurity = 434,
  ModeMOS = 435,
  ModeInService = 436,
  ModeInspection = 437,
  ModeIndependent = 438,
  ModeLobbyParking = 439,
  ModeCarToLobby = 440,
  ModeCodeBlue = 441,
  ModeFirePhase2 = 442,
  ModeGroupService = 443,
  ModeSabbath = 444,
  DoorRearOpenSequence = 450,
  DoorOpenSequence = 451,
  DoorGateLock = 452,
  DoorHold = 453,
  TrafficUpPilot = 460,
  TrafficDownPilot = 461,
  TrafficPilotHold = 462,
  TrafficCancelRearCallRequest = 463,
  TrafficValidPosition = 464,
  TrafficCarIsInBlindHatch = 465,
  TrafficRemoveNextUpRequence = 466,
  TrafficCancellCallRequest = 467,
  LoadLight = 470,
  LoadNormal = 471,
  LoadDispatch = 472,
  LoadHeavy = 473,
  LoadOverload = 474,
  SwingConfigured = 480,
  SabbathConfigured = 481,
  LwConfigured = 482,
  EarthquakeConfigured = 483,
  EpConfigured = 484,
  SwingActive = 485,
  SabbathActive = 486,
  InGroupActive = 487,
  HallCallBypassActive = 488,
  ParkedActive = 489,
  AutoStopConfigured = 490,
  AutoStopActive = 491,
  FloodConfigured = 492,
  FloodActive = 493,
  CarToFloorActive = 494,
  EmergencyAlarmConfigured = 495,
  EmergencyAlarmActive = 496,
  EmergencyAlarmSwAcknowledgeAllowed = 497,
  DispatchEp1Configured = 498,
  DispatchEp2Configured = 499,
  DispatchEp1Active = 500,
  DispatchEp2Active = 501,
  SecurityMonitorActive = 502,
  BsiInputActive = 503,
  OperationTime = 504,
  ActiveEligibilityConfig = 505,
  ActiveModeConfig = 506,
  NumberOfFloors = 507,
  NumberOfControllers = 508,
  JobNumber = 509,
  FrontDoorPhysicallyOpen = 510,
  RearDoorPhysicallyOpen = 511,
  ProximityAtFloor = 512,
  ProximityAboveFloor = 513,
  ProximityBelowFloor = 514,
  ProximityInvalid = 515,
  DispatchingTimerActive = 516,
  GeneratorRunning = 517,
  CarGateLocked = 518,
  DirChangeOperation = 519,
  EngineerOnSite = 520,
  HOCarRAndControllerSSUP = 521,
  HighSpeedOperation = 522,
  Local = 523,
  Mains = 524,
  ROIN = 525,
  RSIN = 526,
  RSKMFailure = 527,
  RegulatedOperation = 528,
  RemoteOperation = 529,
  SafetyStringClosed = 530,
  SafetyStringOpen = 531,
  SafetySwitchOpen = 532,
  StarOperation = 533,
  TPWR = 534,
  StopSwitch = 535,
  Delta = 536,
  Ready = 537,
  PowerBackUp = 538,
  PowerGenerator = 539,
  Auto = 540,
  PitFlood = 541,
  MotorThermalTOL = 542,
  UpHighSpeed = 543,
  UpFloorSeek = 544,
  UpSlowSpeed = 545,
  DownHighSpeed = 546,
  DownFloorSeek = 547,
  DownSlowSpeed = 548,
  DownLeveling = 549,
  FanLightDisabled = 550,
  MotorOn = 551,
  PitDetection = 552,
  AutoDoorEnabled = 553,
  CarReset = 554,
  DBResistorTempError = 555,
  DoorLockBottom = 556,
  DoorLockMiddle = 557,
  DoorLockTop = 558,
  ElectricEye = 559,
  EmergencyPowerRecall = 560,
  FaultedOutOfService = 561,
  RearDoorLockMiddle = 562,
  RearElectricEye = 563,
  SF_DBR = 564,
  SF_DCL = 565,
  SF_DRV = 566,
  SF_GDL = 567,
  SF_GRP = 568,
  SF_IO = 569,
  SF_NGL = 570,
  SF_RDY = 571,
  SF_SPB = 572,
  SF_STP = 573,
  SafetyEdge = 574,
  WaitingForDoorClosed = 575,
  AnualSafetyTest = 576,
  BinaryPositionInputError = 577,
  DownLevelInput = 578,
  EmergencyPowerSelToRun = 579,
  InspOrLockBypassFault = 580,
  NoHCPower = 581,
  NoLCPower = 582,
  NoSSInput = 583,
  TopOffCarrCommunicationError = 584,
  UpLevelInput = 585,
  sf_ShD = 586,
  DoorReversalDevice = 587,
  LoadNoneStop = 588,
  StopButton = 589,
  _308Bm1 = 590,
  _308Bm2 = 591,
  Bypass = 592,
  CabinetTemp = 593,
  Cphll = 594,
  Cphlr = 595,
  Cphul = 596,
  Cphur = 597,
  Cpvll = 598,
  Cpvlr = 599,
  Cpvrsl = 600,
  Cpvrsr = 601,
  Cpvul = 602,
  Cpvur = 603,
  Egress = 604,
  Faults = 605,
  Firrly = 606,
  Hrsl = 607,
  Hrsr = 608,
  LGBRDS = 609,
  LowerStop = 610,
  Maintenance = 611,
  NoPower = 612,
  PublicOperation = 613,
  Pwctft = 614,
  Pwltft = 615,
  Qf12Ft = 616,
  Qf1Flt = 617,
  Qf2Flt = 618,
  Qf30Ft = 619,
  Qf31Ft = 620,
  Rdbtlt = 621,
  Rdbtrt = 622,
  Rdtlt = 623,
  Rdtrt = 624,
  Shbrds = 625,
  Sleep = 626,
  TopSpeed = 627,
  UpStop = 628,
  WARNS = 629,
  Wnvm2 = 630,
  Wnvm1 = 631,
  Cpvrur = 632,
  Cpvrul = 633,
  Cpvrlr = 634,
  Cpvrll = 635,
  BSI = 636,
  Flt1 = 637,
  Flt12 = 638,
  Flt16 = 639,
  Flt2 = 640,
  Flt32 = 641,
  Flt4 = 642,
  Flt64 = 643,
  Flt8 = 644,
  InspectionAccess = 645,
  InspectionCarTop = 646,
  InspectionInCar = 647,
  ET1 = 648,
  ET2 = 649,
  EmergencyMedicalTripPhase1 = 650,
  EmergencyMedicalTripPhase2 = 651,
  EmergencyPowerBlockFeeder1 = 652,
  EmergencyPowerBlockFeeder2 = 653,
  EmergencyPowerEvacuation = 654,
  EmergencyPowerEvacuationDone = 655,
  EmergencyPowerEvacuationFailed = 656,
  EmergencyPowerFeeder2 = 657,
  EmergencyPowerOperation = 658,
  FireEmergency = 659,
  FireEmergencyService = 660,
  M10EmergencyTrip = 661,
  MaxLoad = 662,
  NextCarOperation = 663,
  OverTemp = 664,
  PowerSwitch = 665,
  PressureSwitch = 666,
  PriorityTrip = 667,
  RearStopped = 668,
  FirePhase1 = 669,
  BrakeLiftSwitchError = 670,
  DoorZoneFault = 671,
  NoAutomaticDoors = 672,
  NoPotentialInput = 673,
  PositionError = 674,
  LowOil = 675,
  Overspeed = 676,
  TestMode = 677,
  Error = 678,
  Stopped = 679,
  ShuttleServiceCommanded = 680,
  BsiInputConfigured = 681,
  JailConfigured = 682,
  JailSoftwareActive = 683,
  JailHardwareActive = 684,
  StepWheelSpeed1 = 685,
  StepWheelSpeed2 = 686,
  LeftHandrailSpeed = 687,
  RightHandrailSpeed = 688,
  GoingEnableDown = 689,
  GoingEnableUp = 690,
  DoorOpenIntent = 691,
  CarCallDoorFlag = 692,
  DownCallDoorFlag = 693,
  ShortDoorTime = 694,
  LobbyDoorTime = 695,
  DoorClosePower = 696,
  DoorTimeShortening = 697,
  DoorCloseComplete = 698,
  CarSafetyBypass = 699,
  PositionStepUp = 700,
  PositionStepDown = 701,
  FireWarningIndicator = 702,
  HeavyLoadInput = 703,
  UpperFloorParkingIntent = 704,
  LowerFloorParkingIntent = 705,
  CarRunning = 706,
  DoorsNotLocked = 707,
  CarCallRegistered = 708,
  HallCallRegistered = 709,
  UpperJunctionBoxSafety = 710,
  LowerJunctionBoxSafety = 711,
  SkirtingTop = 712,
  SkirtingBottom = 713,
  StepUpthrust = 714,
  CombplateTop = 715,
  MousetrapTop = 716,
  StepLevelSwitchTop = 717,
  StepLevelSwitchBottom = 718,
  MousetrapBottom = 719,
  CombplateBottom = 720,
  MissingStepSwitch = 721,
  HandrailSpeedMonitor = 722,
  BrokenStep = 723,
  ChainSwitch = 724,
  MaintenanceBrakeSwitch = 725,
  SoftStart = 726,
  TUVSimulation = 727,
  Starting = 728,
  ConstructionMode = 729,
  Stopping = 730,
  BrakeBurnishing = 731,
  BrakeLiftCommand = 732,
  SafetyCircuitSupply = 733,
  AccessCoverUpper = 734,
  SkirtUpperRight = 735,
  SkirtUpperLeft = 736,
  CombplateUpperRight = 737,
  CombplateUpperLeft = 738,
  HandrailInletUpperRight = 739,
  HandrailInletUpperLeft = 740,
  HandrailInletLowerRight = 741,
  HandrailInletLowerLeft = 742,
  SkirtLowerRight = 743,
  SkirtLowerLeft = 744,
  SkirtMiddleRight = 745,
  SkirtMiddleLeft = 746,
  TrailWheelSwitch = 747,
  StartingDown = 748,
  RearDoorLockedStatus = 749,
  MechanicOnSiteMode = 750,
  StartingUp = 751,
  NotInNormalService = 752,
  CancelRearDown = 753,
  CarNotFailed = 754,
  DownTerminalSlowdown = 755,
  SlowDownInitiated = 756,
  DoorsNotClosed = 757,
}
